import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PackageOrderList from './PackageOrderList';
import PackageNewOrderList from './PackageNewOrderList';
import PackagePackedOrderList from './PackagePackedOrderList';
import { withRouter } from 'react-router-dom';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function PackageTabForProgress() {
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
<Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: 'fit-content' }}>
  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
    <Tab label="Assigned Orders" {...a11yProps(0)} />
    <Tab label="In Progress Orders" {...a11yProps(1)} />
    <Tab label="Completed Orders" {...a11yProps(2)} />
  </Tabs>
</Box>
</Box>
      <CustomTabPanel value={value} index={0}>
      <PackageOrderList />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <PackageNewOrderList />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <PackagePackedOrderList />
      </CustomTabPanel>
    </Box>
  );
}


export default withRouter(PackageTabForProgress); // Wrap with withRouter